import _asyncToGenerator from "/home/runner/work/mainrepo/mainrepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { ProtocolLogger } from './protocol-logger';
export class ProtocolLoggerMemoryStorage {
  constructor(name) {
    this.name = name;
    this.fullLog = [];
  }
  add(entry) {
    this.fullLog.push(entry);
  }
  clear() {
    var _this = this;
    return _asyncToGenerator(function* () {
      _this.fullLog = [];
    })();
  }
  getAll() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      return _this2.fullLog;
    })();
  }
}
/**
 * NOTE: StorageProtocolLogger child classes that are platform-specific can be decorated with @Injectable which will allow dependency injection!
 */
export class StorageProtocolLogger extends ProtocolLogger {
  assignToProtocol(protocol) {
    super.assignToProtocol(protocol);
    this.storage = this.createStorage();
  }
  getLog() {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      return _this3.storage.getAll();
    })();
  }
  log(entry) {
    this.storage.add(entry);
  }
  clearLog() {
    this.storage.clear();
  }
}
// other loggers e.g. for file logging can be found in backend.